export default {
  heading: 'ITC',
  body: `'DM Sans Regular', sans-serif`,
  dmsans: 'DM Sans Regular',
  itc: 'ITC'
}
